import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Yemen`}</h3>
    <p>{`In 2019, WFP’s emergency response in Yemen was its largest anywhere in the world. Some 24 million people were in need of humanitarian assistance, of which 20 million were food insecure. Thanks to donors like the EU, WFP was able to launch an unprecedented expansion of food assistance, scaling up by 50 percent and reaching more than `}<a parentName="p" {...{
        "href": "https://docs.wfp.org/api/documents/e2a6188dc60d4636ba0ebc20321441d6/download/?_ga=2.70031632.1470627730.1590061564-2082888029.1574075419"
      }}>{`12 million`}</a>{` people each month across the country.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      